import {Provider} from 'react-redux';
import store,{persister} from './Redux/Store';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';

const Root = ()=>{

return(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persister}>
			<App/>	
		</PersistGate>
	 </Provider>
	)

}

export default Root